@if (isLoading) {
<app-table-skeleton-loader [columns]="columns"
	[haveMultiActions]="multiActions ? true : false"></app-table-skeleton-loader>
}
@else {
<form>
	<div style="overflow: auto;" [style.max-height]="80 * (tableHeightElems + 1) + 'px'">
		<table class="table tas-table-striped table-hover table-fixed m-0"
			[class.qai-table-head_solid]="tableHead === 'solid'">
			@if (tableHead !== 'none') {
			<thead style="position: sticky; top: 0; z-index: 1;">
				<tr>
					@if (multiActions) {
					<th scope="col"></th>
					}
					@for (col of columns; track col.key) {
					@if (col.type !== 'hidden') {
					<th scope="col" [sortable]="col.key" (sort)="totalItems && onSort($event)"
						[direction]="currentSort.column === col.key ? currentSort.direction : ''"
						[class.sortable]="totalItems"
						[class.text-center]="col.type === 'counter' || col.type === 'user-counter' || col.type === 'list'  || col.type === 'boolean' ">
						{{ col.label }}
					</th>
					}
					}
				</tr>
			</thead>
			}
			<tbody>
				@for (item of items; track item[columns[0].key]) { <!-- columns[0].key must be unique or identifier -->
				<tr [class.table-active]="isSelected(item[columns[0].key])"
					(click)="clickableRow && openDetail($event, item)" [attr.role]="clickableRow && 'button'">
					@if (multiActions) {
					<td class="px-1 qai-checkbox-cell">
						<div class="form-check d-flex justify-content-center">
							<input class="form-check-input" name="checkbox" type="checkbox" (change)="selectRow(item)"
								(click)="$event.stopPropagation()" />
						</div>
					</td>
					}
					@for (col of columns; track $index) {
					@switch (col.type) {
					@case('string') {
					<td [class.col-4]="col.fixedSize === true">
						<ngb-highlight [result]="item[col.key]" [term]="searchTerm" />
					</td>
					}
					@case('email') {
					<td>
						<ngb-highlight [result]="item[col.key]" [term]="searchTerm" />
					</td>
					}
					@case ('number') {
					<td>{{ item[col.key] | number }}</td>
					}
					@case ('byte') {
					<td>{{ item[col.key] | byteConverter }}</td>
					}
					@case ('date') {
					<td>{{ item[col.key] | date: 'dd/MM/yyyy' }}</td>
					}
					@case ('counter') {
					<td class="text-center">
						<span class="py-2">
							{{ item[col.key] | number }}
						</span>
					</td>
					}
					@case ('list') {
					<td class="text-center">
						<div ngbDropdown class="qai-list-dropdown" (click)="$event.stopPropagation()"
							[container]="'body'">
							<span [class]="item[col.key]?.length > 0 ?
										  'badge rounded-pill qai-table-item-counter px-3 py-2 tas-table-item-counter_clickable' : ''" id="listdd"
								ngbDropdownToggle>
								{{ item[col.key]?.length || 0 }}
							</span>
							<div ngbDropdownMenu aria-labelledby="listdd" class="qai-dropdown-list-menu shadow">
								@for (elem of item[col.key]; track $index) {
								<button class="tas-dropdown-list-menu_item px-4 py-3" ngbDropdownItem
									(click)="subListElemClick($event, elem, col.key)">
									{{ elem['name'] }}
								</button>
								}
							</div>
						</div>
					</td>
					}
					@case ('user-counter') {
					<td class="text-center">
						<span class="qai-user-coutner">
							{{ item[col.key] | number }}
							<fa-icon [icon]="faUser" size="sm"></fa-icon>
						</span>
					</td>
					}
					@case ('boolean') {
					<td class="text-center">
						{{ item[col.key] === true ? "Si" : "No" }}
					</td>
					}
					@case ('file-icon') {
					<td><app-file-icon [fileMimeType]="item[col.key]"></app-file-icon></td>
					}
					@case ('status') {
					<td class="d-flex align-items-center">
						<app-badge-status [status]="item[col.key]" [reason]="item['reason']"></app-badge-status>
						@if (item['verified'] === false) {
						<button class="btn btn-primary ms-2 px-2"
							style="padding-top: 1px; padding-bottom: 1px; font-size: 75%;"
							(click)="singleActionEvent.emit({ item, action: 'verify' })">
							Verifica
						</button>
						}
					</td>
					}
					@case ('inclusion') {
					<td>
						@if (item[col.key] === 'INCLUDE') {
						<fa-icon [icon]="faPlus" style="color: #387069;"></fa-icon>
						<span class="ms-2 fw-bold">Incluso</span>
						} @else {
						<fa-icon [icon]="faMinus" style="color: #db0f00;"></fa-icon>
						<span class="ms-2 fw-bold">Escluso</span>
						}
					</td>
					}
					@case ('action') {
					@if (col.actionType === 'delete') {
					<td class="text-end pe-4" (click)="$event.stopPropagation()">
						<fa-icon [icon]="faTrash" role="button"
							(click)="singleActionEvent.emit({ item, action: 'delete' })"></fa-icon>
					</td>
					} @else if (col.actionType === 'unlink') {
					<td class="text-end pe-4">
						<button class="btn btn-danger" (click)="singleActionEvent.emit({ item, action: 'unlink' })">
							Abbandona
						</button>
					</td>
					}
					@else if (col.actionType === 'download') {
					<td class="text-end" (click)="$event.stopPropagation()" style="width: 10px;">
						<button class="qai-list-action-button qai-list-icon-button"
							(click)="singleActionEvent.emit({ item, action: 'download' })" [disabled]="item['reason']">
							<fa-icon [icon]="faDownload"></fa-icon>
						</button>
					</td>
					}
					}
					@case ('hidden') { } @default {
					<td>{{ item[col.key] }}</td>
					}
					}
					}
				</tr>
				} @empty {
				<tr>
					<td [attr.colspan]="multiActions ? columns.length + 1 : columns.length" style="text-align: center">
						{{ emptyStateTitle }}
					</td>
				</tr>
				}
			</tbody>
		</table>
	</div>

	@if (totalItems) {
	<div class="d-flex flex-row-reverse p-2 qai-pagination-container" style="height: 5vh;">
		<ngb-pagination [collectionSize]="totalItems" [(page)]="currentPage" [pageSize]="pageSize" [maxSize]="5"
			(pageChange)="onPageChange($event)">
			<ng-template ngbPaginationPages let-page let-pages="pages">
				<div class="ngb-custom-pages-item">
					<div class="mb-3 d-flex flex-nowrap px-2">
						<span id="paginationDescription" class="col-form-label text-nowrap px-2">
							{{ getStartIndex() }} - {{ getEndIndex() }} of {{ totalItems }}
						</span>
					</div>
				</div>
			</ng-template>
			<ng-template ngbPaginationPrevious>{{ '<' }}</ng-template>
					<ng-template ngbPaginationNext>{{ '>' }}</ng-template>
		</ngb-pagination>
	</div>
	}

	<ng-content></ng-content>

	@if (multiActions) {
	<div class="d-flex justify-content-end column-gap-2 pt-3">
		@for (multiAction of multiActions; track $index) {
		<button type="button" [class]="'btn btn-' + multiAction.buttonType"
			(click)="multiActionEvent.emit({ list: selectedRows, action: multiAction.action })"
			[disabled]="(multiAction.action === 'delete' || multiAction.action === 'modify' ) && selectedRows.length === 0">
			<!-- disabilita per il momento solo nel caso di delete se non hai selezionato righe -->
			{{ multiAction.label }}
		</button>
		}
	</div>
	}

</form>
}